/**
 * Punto de entrada para el módulo de bandejas (trays)
 * Exporta las acciones y el reducer por defecto.
 */
import traysReducer from './traysReducer';

export * from './traysActions';

export default traysReducer;
